<template>
  <div>
      <video class="inline-block align-middle mr-3 mini-ad-image" v-if="!!parseInt(meta.has_video)" :src="meta.file"></video>
      <img v-else class="inline-block align-middle mr-3 mini-ad-image" :src="meta.file" :alt="params.data.title">

      <span class="align-middle ads-list-ad-title" :title="params.data.adTitle">
        {{ params.data.adTitle }}
      </span>
  </div>
</template>

<script>
export default {
  computed: {
    meta () {
      return JSON.parse(this.params.data.media || '{}')
    }
  }
}
</script>

<style lang="scss" scoped>
  .mini-ad-image {
    border-radius: 13%;
    width: 82px;
    height: 82px;
  }

  .ads-list-ad-title {
    white-space: initial;
    display: inline-block;
    word-wrap: break-word;
    line-height: 19px;
    max-width: 150px;
  }
</style>
